module.exports = __webpack_public_path__ + "static/step-b-2-2695440cfb13094f594e8bde884f46b8.svg";